import { h, reactive } from 'vue'
import { RouteRecordRaw } from 'vue-router'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { HomeOutlined, HistoryOutlined, SendOutlined, SwapOutlined, ReadOutlined, SettingOutlined } from '@ant-design/icons-vue'
import { getEnv, getLocalData, resetEnvData } from 'complex-utils'
import MenuData, { originMenuType } from '@/class/MenuData'
import develop from '@/data/develop'
import router from '../router'
import role, { hasRole } from './role'

const originMenuList: originMenuType[] = [
  {
    path: '/home',
    name: '首页',
    icon() {
      return h(HomeOutlined)
    },
    component: () => import('@/pages/index/views/home/index.vue')
  },
  {
    path: '/overdue',
    redirect: '/overdue/list',
    name: '逾期处理',
    icon() {
      return h(HistoryOutlined)
    },
    component: () => import('./../layout/PureLayout.vue'),
    children: [
      {
        path: '/overdue/list',
        name: '逾期记录',
        component: () => import('@/pages/index/views/overdue/list/index.vue')
      },
      {
        path: '/overdue/info/:id',
        name (route) {
          return '逾期记录详情' + route!.params.id
        },
        component: () => import('@/pages/index/views/overdue/info/index.vue'),
        hidden: true,
      },
      {
        path: '/overdue/guarantor/list',
        name: '追加担保人',
        component: () => import('@/pages/index/views/overdue/guarantor/list/index.vue'),
        role: role.guarantor.list
      },
      {
        path: '/overdue/guarantor/info/:overdueRecordId/:id',
        name (route) {
          if (route && route.params.id && route.params.id !== 'build') {
            return '追加担保人详情' + route.params.id
          } else {
            return '追加担保人新增'
          }
        },
        component: () => import('@/pages/index/views/overdue/guarantor/info/index.vue'),
        role: role.guarantor.edit,
        hidden: true
      }
    ]
  },
  {
    path: '/external',
    redirect: '/external/vehicle',
    name: '外访管理',
    icon() {
      return h(SendOutlined)
    },
    component: () => import('./../layout/PureLayout.vue'),
    children: [
      {
        path: '/external/vehicle',
        name: '车辆明细',
        component: () => import('@/pages/index/views/external/vehicle/list/index.vue'),
      },
      {
        path: '/external/preservation/list',
        name: '车辆保全申请',
        component: () => import('@/pages/index/views/external/preservation/list/index.vue'),
        role: role.preservation.list
      },
      {
        path: '/external/preservation/info/:id/:overdueRecordOrFlowId/:flowKey',
        name (route) {
          if (route && route.params.id && route.params.id !== 'build') {
            return '车辆保全申请详情' + route.params.id
          } else {
            return '车辆保全申请新增'
          }
        },
        component: () => import('@/pages/index/views/external/preservation/info/index.vue'),
        role: role.preservation.edit,
        hidden: true,
        tab: 'hidden'
      },
    ]
  },
  {
    path: '/handle',
    redirect: '/handle/redeem/list',
    name: '处置管理',
    icon() {
      return h(SwapOutlined)
    },
    component: () => import('./../layout/PureLayout.vue'),
    children: [
      {
        path: '/handle/redeem/list',
        name: '车辆赎回申请',
        component: () => import('@/pages/index/views/handle/redeem/list/index.vue'),
        role: role.redeem.list,
      },
      {
        path: '/handle/redeem/info/:id/:overdueRecordOrFlowId/:flowKey',
        name (route) {
          if (route && route.params.id && route.params.id !== 'build') {
            return '车辆赎回申请详情' + route.params.id
          } else {
            return '车辆赎回申请新增'
          }
        },
        component: () => import('@/pages/index/views/handle/redeem/info/index.vue'),
        role: role.redeem.edit,
        hidden: true,
        tab: 'hidden',
      },
      {
        path: '/handle/dispose/list',
        name: '车辆处置申请',
        component: () => import('@/pages/index/views/handle/dispose/list/index.vue'),
        role: role.dispose.list,
      },
      {
        path: '/handle/dispose/info/:id/:overdueRecordOrFlowId/:flowKey',
        name (route) {
          if (route && route.params.id && route.params.id !== 'build') {
            return '车辆处置申请详情' + route.params.id
          } else {
            return '车辆处置申请新增'
          }
        },
        component: () => import('@/pages/index/views/handle/dispose/info/index.vue'),
        role: role.dispose.edit,
        hidden: true,
        tab: 'hidden',
      },
    ]
  },
  {
    path: '/litigation',
    redirect: '/litigation/pending',
    name: '法诉管理',
    icon() {
      return h(ReadOutlined)
    },
    component: () => import('./../layout/PureLayout.vue'),
    children: [
      {
        path: '/litigation/contract/pending',
        name: '待诉合同',
        component: () => import('@/pages/index/views/litigation/contract/pending/index.vue'),
        role: role.litigation.contract.pending,
      },
      {
        path: '/litigation/application/list',
        name: '诉讼申请',
        component: () => import('@/pages/index/views/litigation/application/list/index.vue'),
        role: role.litigation.application.list,
      },
      {
        path: '/litigation/contract/submit',
        name: '已提交待诉合同',
        component: () => import('@/pages/index/views/litigation/contract/submit/index.vue'),
        role: role.litigation.contract.submit,
      },
      {
        path: '/litigation/application/info/:id/:flowId/:flowKey',
        name (route) {
          if (route && route.params.id && route.params.id !== 'build') {
            return '诉讼申请详情' + route.params.id
          } else {
            return '诉讼申请新增'
          }
        },
        component: () => import('@/pages/index/views/litigation/application/info/index.vue'),
        role: role.litigation.application.edit,
        hidden: true,
        tab: 'hidden',
      },
      {
        path: '/litigation/log',
        name: '诉讼记录',
        component: () => import('@/pages/index/views/litigation/log/list/index.vue'),
        role: role.litigation.log.list,
      },
      {
        path: '/litigation/log/info/:id/:flowKey/:overdueRecordId',
        name (route) {
          if (route && route.params.id && route.params.id !== 'build') {
            return '诉讼记录详情' + route.params.id
          } else {
            return '诉讼记录新增'
          }
        },
        component: () => import('@/pages/index/views/litigation/log/info/index.vue'),
        role: role.litigation.log.list,
        hidden: true,
        tab: 'hidden',
      },
      {
        path: '/litigation/execute/info/:id/:flowId/:flowKey',
        name (route) {
          if (route && route.params.id && route.params.id !== 'build') {
            return '诉讼执行详情' + route.params.id
          } else {
            return '诉讼执行新增'
          }
        },
        component: () => import('@/pages/index/views/litigation/execute/info/index.vue'),
        hidden: true,
        tab: 'hidden',
      },
      {
        path: '/litigation/seize/info/:id/:flowId/:flowKey',
        name (route) {
          if (route && route.params.id && route.params.id !== 'build') {
            return '诉讼查封详情' + route.params.id
          } else {
            return '诉讼查封新增'
          }
        },
        component: () => import('@/pages/index/views/litigation/seize/info/index.vue'),
        hidden: true,
        tab: 'hidden',
      },
    ]
  },
  {
    path: '/system',
    redirect: '/system/serviceProvider',
    name: '配置管理',
    icon() {
      return h(SettingOutlined)
    },
    component: () => import('./../layout/PureLayout.vue'),
    children: [
      {
        path: '/system/serviceProvider',
        name: '服务商管理',
        component: () => import('@/pages/index/views/system/service-provider/index.vue'),
        role: role.serviceProvider.list
      },
      {
        path: '/system/parkingPoint',
        name: '停车点管理',
        component: () => import('@/pages/index/views/system/parking-point/index.vue'),
        role: role.parkingPoint.list
      },
      {
        path: '/system/assignRule',
        name: '分派规则管理',
        component: () => import('@/pages/index/views/system/assign-rule/index.vue'),
        role: role.assignRule.list
      },
      {
        path: '/system/area',
        name: '区域管理',
        component: () => import('@/pages/index/views/system/area/index.vue'),
        role: role.area.list
      },
    ]
  },
]

let unauthorized = false
resetEnvData(() => {
  if (getLocalData('unauthorized') === '1') {
    unauthorized = true
  }
}, {
  info: '开发环境下展示全部未经授权的页面！'
})

function changeMenu(menu: originMenuType, target = 403) {
  // 更换模板为未授权页面
  if (target === 403) {
    menu.component = () => import('@/views/exception/403.vue')
  } else {
    menu.component = () => import('@/views/exception/404.vue')
  }
  menu.hidden = true
}
function parseMenuByUnauthorized(menu: originMenuType) {
  menu.unauthorized = unauthorized
  if (!unauthorized) {
    // 正常权限需要更换模板为未授权页面
    changeMenu(menu)
    return true
  }
  return false
}

function getMenu(menuList: originMenuType[]) {
  let num = 0
  menuList.forEach(item => {
    if (item.children) {
      const childNum = getMenu(item.children)
      if (childNum === 0) {
        // 无子类则隐藏父类
        item.hidden = true
      }
    }
    if (item.developing && !develop.getData()) {
      // 生产环境下的开发页面替换为404页面:调试模式不更改
      changeMenu(item, 404)
    }
    if (!hasRole(item.role)) {
      if (!parseMenuByUnauthorized(item)) {
        // 菜单更改则判断为有子类
        num++
      }
    } else {
      num++
    }
  })
  return num
}

const menu = reactive(new MenuData({
  $getData(this: MenuData) {
    return new Promise((resolve) => {
      getMenu(originMenuList)
      this.list = this.$formatData(originMenuList)
      resolve({ status: 'success' })
    })
  },
  $addRouter(this: MenuData) {
    if (this.list.length > 0) {
      router.addRoute({
        path: '/',
        redirect: this.list[0].redirect || this.list[0].path,
        component: () => import('../layout/TabLayout.vue'),
        children: [
          ...this.list as RouteRecordRaw[]
        ]
      })
    }
    router.addRoute({
      path: '/:catchAll(.*)',
      redirect: '/404'
    })
  }
}))

export default menu
